import axios from 'axios';
import { useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { useSnackbar } from 'hooks/UseSnackbar';
import { useQueryMonthlyBillInformation } from './useQueryMonthlyBillInformation';
import { useTranslation } from 'react-i18next';
import { sendEmails } from 'services/Emails/Quota/quotaEmailService';

export const useMutationGenerateBills = setOpen => {
    const toast = useSnackbar();
    const [t] = useTranslation();

    const { refetch } = useQueryMonthlyBillInformation({ enabled: false });

    const mutation = useMutation({
        mutationFn: async obj =>
            await axios.post(
                process.env.REACT_APP_SERVER +
                    'api/Quota/Bills/Monthly/Generate',
                obj,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            ),
        onSuccess: res => {
            toast.success(t('QUOTAS.generateBillsSuccess'));
            sendEmails(res.data, 'api/Quota/Bills/Monthly/Generate');
        },
        onError: () => {
            toast.error(t('QUOTAS.generateBillsError'));
        },
        onSettled: () => {
            setOpen(false);
            refetch();
        }
    });

    return mutation;
};
